import { render, staticRenderFns } from "./LoadingPopup.vue?vue&type=template&id=393d48f8&scoped=true"
import script from "./LoadingPopup.vue?vue&type=script&lang=js"
export * from "./LoadingPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d48f8",
  null
  
)

export default component.exports